// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"665a4a8f","867":"20c0018e"}[chunkId] + ".chunk.js";
};